import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

/**
 * One labelled value in the relay order summary. A `group` named by its label, so the label and
 * its value are read together by assistive tech (and can be found together by a test).
 */
const RelayDetailField = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={4} role='group' aria-label={label}>
    <Typography variant='caption' color='text.secondary' display='block'>
      {label}
    </Typography>
    <Typography variant='body2' sx={{ wordBreak: 'break-all' }}>
      {value || 'N/A'}
    </Typography>
  </Grid>
);

RelayDetailField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

RelayDetailField.defaultProps = { value: null };

export default RelayDetailField;
